{
  "version": 1,
  "asset_id": "2733c840-fd20-4069-9f03-84b70d1d5241",
  "project_id": "8d7278d8-f7c2-487a-a967-889b9bac3b6c",
  "url": "/__l5e/assets-v1/2733c840-fd20-4069-9f03-84b70d1d5241/satisfied-business-woman-vending-machine.png",
  "r2_key": "a/v1/8d7278d8-f7c2-487a-a967-889b9bac3b6c/2733c840-fd20-4069-9f03-84b70d1d5241/satisfied-business-woman-vending-machine.png",
  "original_filename": "satisfied-business-woman-vending-machine.png",
  "size": 998734,
  "content_type": "image/png",
  "created_at": "2026-07-03T06:50:56Z"
}
